import { render, staticRenderFns } from "./modal-manage-quick-chat.vue?vue&type=template&id=1dd0d1c2&"
import script from "./modal-manage-quick-chat.vue?vue&type=script&lang=js&"
export * from "./modal-manage-quick-chat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports